import { createI18n } from 'vue-i18n';

// the language codes follow
// Internet Engineering Task Force (IETF) Best Current Practice (BCP) 47
// ISO 639-1 language codes

import ar from './ar';
import az from './az';
import de from './de';
import el from './el';
import en from './en';
import es from './es';
import fi from './fi';
import fr from './fr';
import hi from './hi';
import id from './id';
import ja from './ja';
import ms from './ms';
import pt from './pt';
import ptBr from './pt-br';
import ru from './ru';
// hide Ukranian for now: import uk from './uk';
import zh from './zh';


export const defaultLocale = 'en';

const fallbackLocales = Object.freeze({
    pt: ['pt-BR'],
    default: defaultLocale
});

const messages = Object.freeze({
    ar,
    az,
    de,
    el,
    en,
    es,
    fi,
    fr,
    hi,
    id,
    ja,
    ms,
    pt,
    'pt-BR': ptBr,
    ru,
    zh
});

export const supportedLocales = Object.freeze(Object.keys(messages));

let i18nInstance = null;

const installLegacyCompat = (instance) => {
    if (typeof instance.t !== 'function') {
        instance.t = instance.global.t.bind(instance.global);
    }

    if (!Object.getOwnPropertyDescriptor(instance, 'locale')) {
        Object.defineProperty(instance, 'locale', {
            get() {
                return instance.global.locale;
            },
            set(value) {
                instance.global.locale = value;
            }
        });
    }

    return instance;
};

const get = () => {
    if (i18nInstance === null) {
        i18nInstance = createI18n({
            // Preserves Options API compatibility while migrating off deprecated tc/$tc.
            // Legacy mode is deprecated and will be removed in vue-i18n v12.
            // TODO: remove after refactoring i18n usage
            legacy: true,
            locale: defaultLocale,
            fallbackLocale: fallbackLocales,
            messages
        });
        installLegacyCompat(i18nInstance);
    }
    return i18nInstance;
};

export const t = (...args) => {
    const { t: translate } = get().global;
    return translate(...args);
};

// Temporary compatibility wrapper.
// Vue-i18n v9+ uses t() for pluralization.
// TODO: remove after migrating all tc() usages.
export const tc = (key, ...args) => {
    const translate = t;
    return translate(key, ...args);
};

export default {
    get
};
